import React from 'react';
import { createRoot } from 'react-dom/client';

/**
 * @param {Element[]} containers
 * @param {Record<string, React.ComponentType>} components
 */
function renderComponents(containers, components) {
    containers.forEach(container => {
        if (container.dataset.renderedReactComponent) {
            // do not re-render components that have already been rendered
            return;
        }
        let props = tryParse(container.dataset.props);
        const component = components[container.dataset.reactComponent];
        if (component) {
            const element = React.createElement(component, props);
            const root = createRoot(container);
            root.render(element);
            container.dataset.renderedReactComponent = true;
        }
    });
}

function tryParse(str) {
    return str ? JSON.parse(str) : undefined;
}

/**
 * Renders React components onto a page (client-side)
 * Pass in an object of the React components on the page to be rendered
 * In the HTML, use the [data-react-component] attribute on the element
 * you would like to render the component.
 * (e.g. data-react-component="MyComponent")
 * @param {Record<string, React.ComponentType>} components
 */
function renderReactClient(components) {
    if (typeof window !== 'undefined') {
        const containers = Array.from(document.querySelectorAll('[data-react-component]'));
        renderComponents(containers, components);
    }
}

export default renderReactClient;
